import { render, staticRenderFns } from "./CarIntroduction.vue?vue&type=template&id=e2e1775c&scoped=true"
import script from "./CarIntroduction.vue?vue&type=script&lang=js"
export * from "./CarIntroduction.vue?vue&type=script&lang=js"
import style0 from "./CarIntroduction.vue?vue&type=style&index=0&id=e2e1775c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e1775c",
  null
  
)

export default component.exports